import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import { API_CALLS } from "../../../../../API/api_calls";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { validFile } from "../../../../../utils";
import { FlexColumnCenter } from "../../../../Common/Styles";
import { useFindContent } from "../../useFindContent";
import ImageProps from "./Image";

const Upload = ({
  fileInputRef,
  id,
  setApi_status,
  setUploadedImages,
}: ImageProps.Upload) => {
  const { typography } = useTheme();
  const {
    post_id,
    content_type,
    article_order,
    row_config,
    id: order_id,
  } = useFindContent(id) as ArticleProps.WithImageContent;

  return (
    <Container>
      <UploadContainer
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          const files = e.dataTransfer.files;
          if (!files.length) return;
          const validFiles = validFile(files);
          if (!validFiles.length) return;
          setUploadedImages(validFiles.length);
          API_CALLS.ARTICLE.createOrUpdateArticleContent(
            {
              post_id,
              content_type,
              content_id: String(order_id),
              element_role: row_config.element_role,
              article_order,
              image: validFiles,
            },
            setApi_status
          ).then(() => setUploadedImages(0));
        }}
      >
        <Components.IconButton
          iconType={"Image"}
          disabled={false}
          size="Small"
          kind="Secondary"
          onClick={() => {}}
        />

        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text={"Add an image"}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
        <CloseButtonWrapper>
          <Components.IconButton
            iconType="X"
            disabled={false}
            size="Small"
            kind="Secondary"
            onClick={(e) => {
              e.stopPropagation();
              API_CALLS.ARTICLE.deleteASingleArticleContent(id);
            }}
          />
        </CloseButtonWrapper>
      </UploadContainer>
    </Container>
  );
};

export default Upload;

const UploadContainer = styled(FlexColumnCenter)`
  width: 100%;
  cursor: pointer;
  position: relative;
  height: 125px;
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border: 1px dashed
    ${({ theme }) => theme.Color.border["ui-border-emphasize-brand"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
`;

const Container = styled.div`
  max-width: 906px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
